/**
 * Attaches x-trace-id to every API request via @tonnie/sdk.
 * Must be mounted inside SdkProvider. Renders nothing.
 *
 * Part 22 §122 — trace_id propagation.
 */

import { useApiClient } from '@tonnie/sdk';
import { createTraceIdInterceptor } from '@tonnie/observability';
import { useEffect } from 'react';

export function TraceIdBridge(): null {
  const client = useApiClient();

  useEffect(() => {
    client.addRequestInterceptor(createTraceIdInterceptor());
  }, [client]);

  return null;
}
